import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import logoUrl from '@Assets/logos/lili-logo-blue.svg';
import { useBoundStore } from '@Store/useBoundStore';
import { Icon, Icons } from '@Components/icon/Icon';

export const DirectWelcomeHeader = () => {
  const { t } = useTranslation();
  const customerLogoUrl = useBoundStore((state) => state.customer.customerLogoUrl);
  return (
    <div className='flex flex-col items-center w-full'>
      <div className='flex items-center justify-center gap-[12px] mb-[28px] w-full max-w-full  md:mt-[110px] mt-[13px] tab-landscape:mt-[0px]'>
        <img className='w-[65px] h-[65px] flex-shrink-0' src={logoUrl} alt='Lili logo' />
        {customerLogoUrl && (
          <Icon
            icon={Icons.Plus}
            className='stroke-text-brand-primary text-text-brand-primary w-[24px] h-[24px]'
          />
        )}
        {customerLogoUrl && (
          <div className='min-w-0 flex-shrink'>
            <img
              className='max-w-[280px] w-full h-auto max-h-[78px] object-contain'
              src={customerLogoUrl}
              alt='Partner logo'
            />
          </div>
        )}
      </div>
      <Heading.H5 fontWeight={FontWeight.SEMIBOLD}>{t('pages.home.getStarted')}</Heading.H5>
    </div>
  );
};
